// Update Existing result text. Rows the server refused (for example because
// they would change a reconciled month's balance) are listed with the
// server's own message; the other rows were applied.
const MAX_LISTED = 20;

export function bulkUpdateSummary(results = {}) {
  const errors = Array.isArray(results.errors) ? results.errors : [];
  const lines = [
    `Updated ${results.updated ?? 0} of ${results.total ?? 0} transactions.`,
    `Refused: ${results.failed ?? errors.length}`
  ];
  if (errors.length > 0) {
    lines.push('', 'These rows were not changed:');
    errors.slice(0, MAX_LISTED).forEach((e) => {
      lines.push(`- Row ${e.row ?? '?'} (transaction #${e.id ?? '?'})${e.month ? `, ${e.month}` : ''}: ${e.error || 'refused'}`);
    });
    if (errors.length > MAX_LISTED) lines.push(`...and ${errors.length - MAX_LISTED} more.`);
  }
  return lines.join('\n');
}
